import { ROUTES } from "../constants";

// Type definitions for workflow actions
export interface WorkflowAction {
  label: string;
  variant: "primary" | "secondary";
  icon?: string;
  onClick?: () => void;
  loading?: boolean;
  route: string;
}

export interface ReportAnalyticsType {
  workflowName: string;
  workflowId: string;
  workflowShortName: string;
  workflowDescription: string;
  workflowActions: WorkflowAction[];
  disabled?: boolean;
}

//TODO: Remove this once we have API integration
//Temporary variable to feed the cards, this will come from API later
export const reportAnalyticsTypes: ReportAnalyticsType[] = [
  {
    workflowName: "Monthly Financial Report",
    workflowId: "MFR",
    workflowShortName: "MFR",
    workflowDescription:
      "Comprehensive analysis of a company's financial performance and key business metrics for the previous month, comparing key metrics to targets and prior periods to guide decision-making.",
    workflowActions: [
      {
        label: "View",
        variant: "secondary" as const,
        icon: "external",
        route: ROUTES.MFR_VIEW,
      },
      {
        label: "Create",
        variant: "primary" as const,
        icon: "add-plus",
        route: ROUTES.MFR_CREATE,
      },
    ] as WorkflowAction[],
  },
  {
    workflowName: "Net PPM Insights",
    workflowId: "PPM",
    workflowShortName: "PPM",
    workflowDescription:
      "AI-powered financial variance analysis that integrates data, identifies key variance drivers, enables intuitive drill-downs, and generates commentary.",
    workflowActions: [
      {
        label: "View",
        variant: "secondary" as const,
        icon: "external",
        route: ROUTES.NETPPM_VIEW,
      },
      {
        label: "Create",
        variant: "primary" as const,
        icon: "add-plus",
        route: ROUTES.NETPPM_CREATE,
      },
    ] as WorkflowAction[],
  },
  {
    workflowName: "RVM Analysis",
    workflowId: "RVM",
    workflowShortName: "RVM",
    workflowDescription:
      "Comprehensive Rate-Volume-Mix analysis across all regions and channels with variance decomposition for pricing and volume impacts.",
    workflowActions: [
      {
        label: "View",
        variant: "secondary" as const,
        icon: "external",
        route: ROUTES.RVM_VIEW,
      },
      {
        label: "Create",
        variant: "primary" as const,
        icon: "add-plus",
        route: ROUTES.RVM_CREATE,
      },
    ] as WorkflowAction[],
  },
  {
    workflowName: "OPEX Analysis",
    workflowId: "OPX",
    workflowShortName: "OPX",
    workflowDescription:
      "Comprehensive operational expenditure analysis with cost center breakdowns and variance tracking against budgets and forecasts.",
    workflowActions: [
      {
        label: "View",
        variant: "secondary" as const,
        icon: "external",
        route: ROUTES.OPEX_VIEW,
      },
      {
        label: "Create",
        variant: "primary" as const,
        icon: "add-plus",
        route: ROUTES.OPEX_CREATE,
      },
    ] as WorkflowAction[],
    disabled: true,
  },
];
